import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel, Event } from '@angular/router';

@Component({
    selector: 'bhub-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'business-hub-app';
  isIframe = false;
  showTopBar = false;

  constructor(
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    // Log the current environment

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        console.log('Navigation Started:', event);
        this.updateTopBarVisibility(event.url);
      }

      if (event instanceof NavigationEnd) {
        console.log('Navigation Ended:', event);
        this.updateTopBarVisibility(event.url);
      }

      if (event instanceof NavigationError) {
        console.error('Navigation Error:', event);
      }

      if (event instanceof NavigationCancel) {
        console.log('Navigation Cancelled:', event);
      }
    });
  }

  private updateTopBarVisibility(url: string): void {
    // Show top-bar for authenticated routes (dashboard and its children)
    // Hide top-bar for public routes (landing page, home, login-failed)
    // Legal pages are standalone documents read by people who may not have an
    // account at all, so they get no app chrome.
    const publicRoutes = ['/', '/home', '/login-failed', '/terms', '/privacy'];

    this.showTopBar = url.startsWith('/dashboard') ||
                     url.startsWith('/board') ||
                     !publicRoutes.includes(url);
  }
}
